import Vue from 'vue'
import App from './app'
import store from './store'
import router from './router'
import cookies from 'vue-cookies'
import './filters'
import './plugins'
import '@/views/export'
import './utils/dialogDrag'
import './utils/selectLazyLoad'
import '@/assets/css/hiprint-overrides.css'
import jquery from 'jquery'

Vue.config.productionTip = true;
Vue.use(cookies);
Vue.prototype.$ = jquery;

import Meta from "vue-meta";
Vue.use(Meta);

import { hiPrintPlugin } from "vue-plugin-hiprint";
Vue.use(hiPrintPlugin, "$hiprint", false);
// hiPrintPlugin 同时提供了 disAutoConnect 方法
hiPrintPlugin.disAutoConnect();

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});
